<template>
    <div>
      <div v-if="!showLogsOnly" class="col-lg-12">
        <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-notes">
          <i class="fa fa-plus m-r-xs"></i>Add Note
        </button>
      </div>
      <notes-modal :targetId="task.id" :targetType="'tasks'"></notes-modal>
      <notes-logs :notes="taskNotes" v-on:getTaskNotes="getNotes"></notes-logs>
    </div>
</template>
<script>
import axios from 'axios'
import { eventBus } from '../../../../../../../main'
import NotesLogs from '../../../../../../Helpers/Tabs/NotesLogs.vue'
import NotesModal from '../../../../../../Helpers/Modal/NotesModal.vue'

export default {
  props: {
    showLogsOnly: { type: Boolean, default: false },
    task: {}
  },
  data () {
    return {
      taskNotes: []
    }
  },
  mounted () {
    this.getNotes()

    eventBus.$on('loadNotes', () => {
      this.getNotes()
    })
  },
  components: {
    notesLogs: NotesLogs,
    notesModal: NotesModal
  },
  methods: {
    async getNotes () {
      try {
        let r = await axios.get(`/v2/messages?type=note&targets[type]=tasks&targets[id]=${this.task.id}`)
        this.taskNotes = r.data
      } catch (error) {
        this.$toastr.error('Failed to load project history', error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Tasks/Single/Content/Tabs/TaskNotes.vue